import { render, staticRenderFns } from "./FakturaStavkaEdit.vue?vue&type=template&id=aa4a32a4"
import script from "./FakturaStavkaEdit.vue?vue&type=script&lang=js"
export * from "./FakturaStavkaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports